import React from "react";
import Sidebar from "../modules/Sidebar/Sidebar";


function ListOfOrders() {
    
    return (
      <p className="text-black">text</p>
    );
  }
  
  export default ListOfOrders;